import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Alert,
  AlertTitle,
  Typography,
  Box,
  ListItem,
  ListItemText,
  List,
  useTheme,
  Skeleton,
} from '@mui/material';
import {
  getFormattedDateShortMonthDDYYYY,
} from '@marageti/z4-lib';
import { TripRequest, TripRequestStatus } from '@marageti/z4-sdk/lib/travel';
import {
  ViewProps,
} from './types';

const ArchivedTripsView = ({ trips, loading, error }: ViewProps) => {
  const theme = useTheme();

  const renderTripItem = (trip: TripRequest) => {
    const {
      id, status, destinations, createdAt,
    } = trip;
    const isJunk = status === TripRequestStatus.JunkStatus;

    return (
      <ListItem
        key={id}
        divider
        sx={{
          padding: '24px 0',
          '&:hover': {
            textDecoration: 'none',
          },
          color: 'inherit',
          textDecoration: 'none',
        }}
        component={isJunk ? 'div' : RouterLink}
        to={isJunk ? undefined : `/trip-requests/${id}`}
      >
        <ListItemText
          primary={destinations.map((dest) => dest.name).join(', ')}
          secondary={isJunk ? "Unfortunately we weren't able to match this trip." : `Requested ${getFormattedDateShortMonthDDYYYY(createdAt) || ''}`}
          primaryTypographyProps={{ sx: { fontWeight: '700' } }}
          secondaryTypographyProps={{ sx: { color: isJunk ? theme.palette.error.dark : theme.palette.primary.light }, variant: isJunk ? 'captionItalic' : 'caption' }}
        />
      </ListItem>
    );
  };

  return (
    <Box>
      <Typography variant="h2">Archived Trips</Typography>
      <Typography variant="body">Declined and canceled trips.</Typography>
      <List sx={{ marginBottom: 8 }}>
        {loading && <Skeleton width="100%" variant="rounded" height={300} />}
        {(!loading && trips) && trips.map(renderTripItem)}
      </List>
      {(!loading && error) && (
      <Alert severity="error">
        <AlertTitle>There was an error getting archived trips.</AlertTitle>
        {`Code: ${error.code}: ${error.message}`}
        <br />
        {error.id && `ID: ${error.id}`}
      </Alert>
      )}
    </Box>
  );
};

export default ArchivedTripsView;
